import React, { useState } from 'react';

// Brand Logo SVG Component
const AppLogo = ({ className = 'w-7 h-7' }) => (
  <svg
    viewBox="200 250 690 580"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="headerLogoGrad" gradientUnits="userSpaceOnUse" x1="216" y1="0" x2="883" y2="0">
        <stop offset="0%" stopColor="#0a3fe0" />
        <stop offset="15%" stopColor="#1448e1" />
        <stop offset="30%" stopColor="#3a54da" />
        <stop offset="45%" stopColor="#7233bb" />
        <stop offset="60%" stopColor="#a42ea3" />
        <stop offset="75%" stopColor="#c32f94" />
        <stop offset="90%" stopColor="#da3189" />
        <stop offset="100%" stopColor="#e2368c" />
      </linearGradient>
    </defs>
    <path
      fill="url(#headerLogoGrad)"
      fillRule="evenodd"
      d="M 496.00,344.00 C 495.10,340.80 481.87,333.69 479.00,332.00 C 476.13,330.31 454.79,319.09 450.00,317.00 C 445.21,314.91 421.08,306.25 417.00,305.00 C 412.92,303.75 394.81,299.69 391.00,299.00 C 387.19,298.31 370.86,296.21 367.00,296.00 C 363.14,295.79 336.07,295.92 335.00,296.00 C 333.93,296.08 329.80,298.36 329.00,299.00 C 328.20,299.64 325.48,303.11 325.00,304.00 C 324.52,304.89 323.01,308.99 323.00,310.00 C 322.99,311.01 323.00,478.77 323.00,479.00 C 323.00,479.23 323.77,479.99 324.00,480.00 C 324.23,480.01 349.77,480.01 350.00,480.00 C 350.23,479.99 351.00,479.23 351.00,479.00 C 351.00,478.77 350.99,328.68 351.00,328.00 C 351.01,327.32 353.33,325.11 354.00,325.00 C 354.67,324.89 366.61,324.80 369.00,325.00 C 371.39,325.20 386.69,327.26 390.00,328.00 C 393.31,328.74 417.84,335.17 423.00,337.00 C 428.16,338.83 451.85,349.45 455.00,351.00 C 458.15,352.55 471.68,360.52 474.00,362.00 C 476.32,363.48 487.69,371.82 488.00,372.00 C 488.31,372.18 489.90,371.34 490.00,371.00 C 490.10,370.66 496.90,347.20 496.00,344.00 Z M 263.00,361.00 C 262.36,403.88 261.64,452.12 261.00,495.00 C 248.20,496.60 233.80,498.40 221.00,500.00 C 221.00,507.36 221.00,515.64 221.00,523.00 C 282.12,523.96 402.75,528.01 412.00,526.00 C 421.25,523.99 432.40,491.32 442.00,475.00 C 454.16,504.12 467.84,536.88 480.00,566.00 C 486.08,562.48 497.98,558.36 499.00,555.00 C 500.02,551.64 524.84,434.64 537.00,378.00 C 550.12,454.48 564.88,540.52 578.00,617.00 C 584.40,614.12 596.77,611.29 598.00,608.00 C 599.23,604.71 621.12,516.20 632.00,473.00 C 638.40,480.36 647.12,495.96 652.00,496.00 C 656.88,496.04 729.31,473.85 741.00,474.00 C 752.69,474.15 806.38,486.88 810.00,498.00 C 813.62,509.12 808.64,621.76 808.00,680.00 C 774.08,679.68 718.73,676.21 702.00,679.00 C 685.27,681.79 623.12,704.84 586.00,717.00 C 609.36,700.04 645.77,669.77 659.00,664.00 C 672.23,658.23 762.43,650.04 774.00,635.00 C 785.57,619.96 776.84,516.38 776.00,512.00 C 775.16,507.62 757.64,507.24 749.00,505.00 C 748.36,539.24 758.17,599.02 747.00,612.00 C 735.83,624.98 640.37,640.49 626.00,648.00 C 611.63,655.51 574.32,693.56 550.00,715.00 C 523.44,692.60 482.44,652.96 467.00,645.00 C 451.56,637.04 362.45,621.36 354.00,614.00 C 345.55,606.64 351.96,566.40 351.00,544.00 C 342.04,544.00 331.96,544.00 323.00,544.00 C 325.24,574.72 319.20,629.02 330.00,640.00 C 340.80,650.98 429.15,659.39 442.00,665.00 C 454.85,670.61 488.92,701.72 511.00,719.00 C 476.44,706.52 420.66,683.05 403.00,680.00 C 385.34,676.95 326.84,680.68 291.00,681.00 C 290.36,637.16 289.64,587.84 289.00,544.00 C 280.36,543.68 270.64,543.32 262.00,543.00 C 263.60,596.12 265.40,655.88 267.00,709.00 C 315.00,709.96 393.59,706.69 417.00,712.00 C 440.41,717.31 537.67,774.76 558.00,775.00 C 578.33,775.24 650.29,719.96 670.00,715.00 C 689.71,710.04 782.88,708.20 836.00,705.00 C 836.96,638.76 838.04,564.24 839.00,498.00 C 849.88,497.36 870.00,497.36 873.00,496.00 C 876.00,494.64 879.80,483.76 883.00,478.00 C 844.60,470.64 801.40,462.36 763.00,455.00 C 788.60,424.60 839.37,366.40 843.00,360.00 C 846.63,353.60 845.19,320.33 843.00,314.00 C 840.81,307.67 821.85,285.26 816.00,282.00 C 810.15,278.74 779.30,274.03 773.00,275.00 C 766.70,275.97 744.37,294.08 738.00,294.00 C 731.63,293.92 697.15,273.65 689.00,274.00 C 680.85,274.35 647.75,294.44 644.00,298.00 C 640.25,301.56 632.55,322.86 632.00,328.00 C 631.45,333.14 633.97,359.04 637.00,364.00 C 640.03,368.96 680.52,416.36 701.00,441.00 C 708.36,435.56 716.64,429.44 724.00,424.00 C 704.16,400.64 664.82,357.35 662.00,351.00 C 659.18,344.65 669.95,312.59 673.00,309.00 C 676.05,305.41 697.58,302.38 702.00,304.00 C 706.42,305.62 728.52,324.40 741.00,334.00 C 750.60,325.04 767.63,307.87 771.00,306.00 C 774.37,304.13 791.31,302.88 795.00,304.00 C 798.69,305.12 812.11,315.62 814.00,319.00 C 815.89,322.38 819.54,341.08 818.00,345.00 C 816.46,348.92 791.53,386.35 785.00,393.00 C 778.47,399.65 708.37,458.67 703.00,462.00 C 697.63,465.33 669.54,471.03 664.00,468.00 C 658.46,464.97 641.31,429.36 639.00,427.00 C 636.69,424.64 625.40,423.60 619.00,422.00 C 609.08,454.96 597.92,492.04 588.00,525.00 C 574.88,444.04 560.12,352.96 547.00,272.00 C 539.64,275.20 525.13,278.15 524.00,282.00 C 522.87,285.85 494.76,427.52 481.00,496.00 C 473.32,474.56 458.64,431.86 457.00,429.00 C 455.36,426.14 444.08,423.56 438.00,421.00 C 425.84,445.32 412.08,490.76 400.00,497.00 C 387.92,503.24 325.88,497.00 291.00,497.00 C 290.36,461.48 288.64,388.77 289.00,386.00 C 289.36,383.23 304.62,384.43 306.00,382.00 C 307.38,379.57 306.00,364.32 306.00,356.00 C 292.24,357.60 276.76,359.40 263.00,361.00 Z"
    />
  </svg>
);

export default function MobileOnboarding({ onFinish, onSignIn, onBack }) {
  const [screen, setScreen] = useState(1);

  const handleNext = () => {
    if (screen < 3) {
      setScreen(screen + 1);
    } else if (onFinish) {
      onFinish();
    }
  };

  const handleBack = () => {
    if (screen > 1) {
      setScreen(screen - 1);
    } else if (onBack) {
      onBack();
    }
  };

  return (
    <div
      className="relative w-full h-[100dvh] bg-white overflow-hidden flex flex-col justify-between"
      style={{ fontFamily: 'Inter, sans-serif', maxWidth: '430px', margin: '0 auto' }}
    >
      <style>{`
        @keyframes floating { 0%,100% { transform: translateY(0px); } 50% { transform: translateY(-6px); } }
        .float-anim { animation: floating 3s ease-in-out infinite; }
      `}</style>

      {/* TOP HEADER */}
      <div className="w-full flex items-center justify-between px-6 pt-5 pb-2 z-20 shrink-0">
        <button
          onClick={handleBack}
          className="w-10 h-10 rounded-full flex items-center justify-center bg-white shadow-sm border border-slate-100 active:scale-95 transition-all cursor-pointer"
        >
          <span className="material-symbols-outlined text-[#1a1c2e]" style={{ fontSize: '20px' }}>
            arrow_back
          </span>
        </button>

        <div className="w-12 h-12 rounded-full bg-white shadow-md border border-slate-100 flex items-center justify-center p-2.5 transition-transform hover:scale-105">
          <AppLogo className="w-7 h-7" />
        </div>
      </div>

      {/* MAIN ORBIT ARTWORK AREA (Fixed relative height section) */}
      <div
        className="relative flex-1 min-h-[300px] flex items-center justify-center overflow-hidden shrink-0"
        style={{ background: 'linear-gradient(180deg, #ffffff 0%, #f7f8fe 50%, #ffffff 100%)' }}
      >
        {/* Background Dot Grids */}
        <div
          className="absolute top-4 right-6 w-20 h-28 opacity-30 pointer-events-none"
          style={{
            backgroundImage: 'radial-gradient(#b0b7d6 1.5px, transparent 1.5px)',
            backgroundSize: '12px 12px',
          }}
        />
        <div
          className="absolute bottom-6 left-6 w-20 h-28 opacity-30 pointer-events-none"
          style={{
            backgroundImage: 'radial-gradient(#b0b7d6 1.5px, transparent 1.5px)',
            backgroundSize: '12px 12px',
          }}
        />

        {/* Outer Circular Orbit Ring */}
        <div
          className="absolute border border-dashed rounded-full"
          style={{ width: '210px', height: '210px', borderColor: '#d8ddf0' }}
        />

        {/* Central Graphic Placeholder Container */}
        <div className="z-10 w-24 h-28 flex items-center justify-center">
          {screen === 1 && (
            <div
              className="w-24 h-28 rounded-2xl bg-white flex flex-col items-center justify-center p-3 border border-indigo-100 float-anim transition-all duration-300"
              style={{ boxShadow: '0 12px 30px rgba(90, 102, 241, 0.15)' }}
            >
              <span className="material-symbols-outlined text-[#2f5fff]" style={{ fontSize: '38px' }}>
                folder_open
              </span>
              <span className="text-[9px] font-bold text-slate-400 mt-2">RECORDS</span>
            </div>
          )}

          {screen === 2 && (
            <div
              className="w-24 h-24 rounded-full bg-white flex items-center justify-center border border-emerald-100 float-anim transition-all duration-300"
              style={{ boxShadow: '0 12px 30px rgba(0, 137, 123, 0.12)' }}
            >
              <span className="material-symbols-outlined text-[#00897B]" style={{ fontSize: '42px' }}>
                smart_toy
              </span>
            </div>
          )}

          {screen === 3 && (
            <div
              className="w-24 h-24 rounded-full bg-white flex items-center justify-center border border-indigo-100 float-anim transition-all duration-300"
              style={{ boxShadow: '0 12px 30px rgba(59, 85, 240, 0.15)' }}
            >
              <span className="material-symbols-outlined text-[#3b55f0]" style={{ fontSize: '42px' }}>
                shield
              </span>
            </div>
          )}
        </div>

        {/* Floating Satellite Cards */}
        <div
          className="absolute z-10 bg-white rounded-2xl shadow-md border border-slate-100 p-2.5 flex flex-col gap-1.5 float-anim"
          style={{ left: '10%', top: '22%', width: '84px', height: '110px' }}
        >
          <div className="w-full h-1.5 bg-slate-200 rounded-full" />
          <div className="w-3/4 h-1.5 bg-slate-100 rounded-full" />
          <div className="w-full h-1.5 bg-slate-100 rounded-full" />
          <div className="w-1/2 h-1.5 bg-slate-100 rounded-full" />
          <div className="mt-auto self-end p-1.5 bg-indigo-50 rounded-xl">
            <span className="material-symbols-outlined text-indigo-500" style={{ fontSize: '16px' }}>
              photo_camera
            </span>
          </div>
        </div>

        {/* Floating Green AI Spark Satellite Icon */}
        <div
          className="absolute z-10 bg-white rounded-full border-2 border-emerald-200 shadow-md flex items-center justify-center float-anim"
          style={{ right: '10%', top: '23%', width: '56px', height: '56px' }}
        >
          <span className="material-symbols-outlined text-[#00897B]" style={{ fontSize: '26px' }}>
            auto_awesome
          </span>
        </div>

        {/* Top Orbit Satellite */}
        <div
          className="absolute z-10 w-9 h-9 rounded-full bg-white shadow-sm border border-slate-100 flex items-center justify-center float-anim"
          style={{ top: '10%', left: '46%' }}
        >
          <span className="material-symbols-outlined text-teal-600" style={{ fontSize: '18px' }}>
            pill
          </span>
        </div>

        {/* Bottom Orbit Satellite */}
        <div
          className="absolute z-10 w-9 h-9 rounded-full bg-white shadow-sm border border-slate-100 flex items-center justify-center float-anim"
          style={{ bottom: '10%', left: '46%' }}
        >
          <span className="material-symbols-outlined text-teal-600" style={{ fontSize: '18px' }}>
            check_circle
          </span>
        </div>
      </div>

      {/* BOTTOM CONTENT AREA (Strict symmetrical boundaries) */}
      <div className="w-full px-8 pb-8 flex flex-col items-center text-center shrink-0">
        {/* Dynamic Pagination Dots - Fixed Height Container */}
        <div className="flex gap-1.5 items-center justify-center h-4 mb-3">
          {[1, 2, 3].map((step) =>
            screen === step ? (
              <div
                key={step}
                className="w-6 h-2 rounded-full transition-all duration-300"
                style={{ background: 'linear-gradient(90deg, #e62e8a, #5a66f1)' }}
              />
            ) : (
              <div key={step} className="w-2 h-2 rounded-full bg-slate-300 transition-all duration-300" />
            )
          )}
        </div>

        {/* Content Box with fixed height (180px) so layout won't shift */}
        <div className="w-full h-[180px] flex flex-col items-center justify-start pt-1">
          {screen === 1 && (
            <>
              <div
                className="px-3.5 py-1 rounded-full font-bold border flex items-center gap-1.5 mb-2.5"
                style={{ background: '#eef1ff', color: '#2f5fff', borderColor: '#c7d2fe', fontSize: '11px', letterSpacing: '0.04em' }}
              >
                HEALTH RECORDS
              </div>
              <h1 className="font-extrabold text-[#1a1c2e] text-xl leading-snug mb-2 h-[56px] flex items-center justify-center">
                One Place for All Your <br /> Health Records
              </h1>
              <div className="w-10 h-1 rounded-full mb-3 shrink-0" style={{ background: 'linear-gradient(90deg, #e62e8a, #5a66f1)' }} />
              <p className="text-gray-500 text-sm leading-relaxed px-2">
                Digitize and store all your prescriptions, lab reports and medical records in one secure place.
              </p>
            </>
          )}

          {screen === 2 && (
            <>
              <div
                className="px-3.5 py-1 rounded-full font-bold border flex items-center gap-1.5 mb-2.5"
                style={{ background: '#e6fffa', color: '#00796b', borderColor: '#b2f5ea', fontSize: '11px', letterSpacing: '0.04em' }}
              >
                <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                  auto_awesome
                </span>
                AI POWERED
              </div>
              <h1 className="font-extrabold text-[#1a1c2e] text-xl leading-snug mb-2 h-[56px] flex items-center justify-center">
                AI Reads Your Reports <br /> Automatically
              </h1>
              <div className="w-10 h-1 rounded-full mb-3 shrink-0" style={{ background: 'linear-gradient(90deg, #e62e8a, #5a66f1)' }} />
              <p className="text-gray-500 text-sm leading-relaxed px-2">
                Scan your prescription bill. Our AI reads it and saves your medicines instantly.
              </p>
            </>
          )}

          {screen === 3 && (
            <>
              <div
                className="px-3.5 py-1 rounded-full font-bold border flex items-center gap-1.5 mb-2.5"
                style={{ background: '#eef0ff', color: '#3730a3', borderColor: '#c7d2fe', fontSize: '11px', letterSpacing: '0.04em' }}
              >
                <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                  shield
                </span>
                PRIVACY & SECURITY
              </div>
              <h1 className="font-extrabold text-[#1a1c2e] text-xl leading-snug mb-2 h-[56px] flex items-center justify-center">
                Your Health Data <br /> Stays Private
              </h1>
              <div className="w-10 h-1 rounded-full mb-3 shrink-0" style={{ background: 'linear-gradient(90deg, #e62e8a, #5a66f1)' }} />
              <p className="text-gray-500 text-sm leading-relaxed px-2">
                Your health data is 100% private. You decide who sees it, and you can revoke access anytime.
              </p>
            </>
          )}
        </div>

        {/* Action Buttons Area (Fixed space reserved for sign in text) */}
        <div className="w-full flex flex-col items-center mt-2">
          <button
            onClick={handleNext}
            className="w-full py-3.5 rounded-2xl text-white font-bold text-base flex items-center justify-center gap-2 active:scale-98 transition-all shadow-lg cursor-pointer"
            style={{
              background: 'linear-gradient(90deg, #e62e8a 0%, #6366f1 100%)',
              boxShadow: '0 8px 24px rgba(230, 46, 138, 0.25)',
            }}
          >
            {screen === 3 ? 'Get Started' : 'Next'}
            <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>
              arrow_forward
            </span>
          </button>

          {/* Reserved height so layout doesn't shift when Sign In appears on step 3 */}
          <div className="h-6 mt-3 flex items-center justify-center">
            {screen === 3 && onSignIn && (
              <p className="text-xs text-gray-500">
                Already have an account?{' '}
                <button onClick={onSignIn} className="text-[#5a66f1] font-bold cursor-pointer hover:underline">
                  Sign In
                </button>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}